import { type PropsWithChildren } from 'react';
import { WidgetFiltersProvider } from '@elfsight/widget-filters';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';

export function FiltersWithThemeProvider({ children }: PropsWithChildren) {
  const { textColor, accentColor, backgroundColor } = useSettings();
  const { t } = useLingui();

  return (
    <WidgetFiltersProvider
      theme={{
        accentColor: accentColor,
        textColor: textColor,
        modalBackground: backgroundColor
      }}
      i18n={{
        Apply: t`Apply`,
        Clear: t`Clear`,
        'Show Less': t`Show less`,
        'Show More': t`Show more`
      }}
    >
      {children}
    </WidgetFiltersProvider>
  );
}
